import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export function ImagesGrid({
  images = [],
  getPreview,
  onSelect,
  rowsNumber = 2,
  isLoading = false,
  loadMore = false,
  itemHeight,
}) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (!images || images.length === 0) {
    return (
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No items found
        </Typography>
      </Box>
    );
  }

  const columns = rowsNumber;
  const gap = 8;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: `${gap}px`,
        overflowY: 'auto',
        flex: 1,
      }}
    >
      {images.map((item, index) => {
        const preview = getPreview ? getPreview(item) : item.src || item.url || item;
        return (
          <Box
            key={index}
            onClick={(e) => {
              if (onSelect) {
                const rect = e.currentTarget.getBoundingClientRect();
                onSelect(item, {
                  x: rect.left,
                  y: rect.top,
                  width: rect.width,
                  height: rect.height,
                });
              }
            }}
            sx={{
              cursor: 'pointer',
              borderRadius: '4px',
              overflow: 'hidden',
              border: '1px solid #e0e0e0',
              aspectRatio: '1',
              height: itemHeight || 'auto',
              '&:hover': {
                borderColor: '#0d83cd',
                boxShadow: '0 0 0 1px #0d83cd',
              },
              transition: 'all 0.15s ease',
            }}
          >
            <img
              src={preview}
              alt=""
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
              loading="lazy"
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default ImagesGrid;
